module.exports = __webpack_public_path__ + "static/media/logo.85534188.png";